// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__23PZ2","row":"Node_row__3PISY","label":"Node_label__2k7ep","footer":"Node_footer__2v5JM"};